import { EXTEND_LOGO, EXTEND_SKU } from '@/data/constants'
import allPromisesWithRetries from '../allPromisesWithRetries'
import { checkIsExtendItem } from '../checkIsExtendItem'

export const checkoutStepsGA = async (step, lineItems, pageName) => {
  const sendToGA = async () => {
    const [
      { gaProducts },
      { getCustomerDetails },
    ] = await allPromisesWithRetries(() => [
      import('@/helpers/GAEvents'),
      import('@/helpers/common'),
    ])
    try {
      const customer = getCustomerDetails()
      const customerId = customer?.customerId
      const customerEmail = customer?.customerEmail
      const visitorType = customerEmail ? 'Logged In' : 'Guest'
      window.dataLayer?.push({
        event: 'checkout',
        ecommerce: {
          currencyCode: 'USD',
          checkout: {
            actionField: { step },
            products: await gaProducts(lineItems),
          },
        },
        customerEmail,
        visitorType,
        customerId,
        pageName,
      })
    } catch (error) {
      console.error(error)
    }
  }
  if (window.loadedAndInteractive) {
    await sendToGA()
  } else {
    window.addEventListener('loadedAndInteractive', sendToGA as () => void, { once: true })
  }
}

export function scrollToTop() {
  window?.scrollTo({ top: 0, behavior: 'smooth' })
}

export function formatProductOptions(options: Array<{ value: string }>) {
  return options.reduce((productOptions, option, i) => `${productOptions
  }${i === 0 ? ': ' : ''} ${option.value.split('~')[0]}${i !== options.length - 1 ? ',' : ''}`, '')
}

export function formatPhoneNumber(phoneNumberString: string) {
  const cleaned = (`${phoneNumberString}`).replace(/\D/g, '')
  const match = /^(\d{3})(\d{3})(\d{4})$/.exec(cleaned)
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`
  }
  return null
}

export type GetSubtotalPrice = (i: { price: number, quantity: number }) => number
export const getSubtotalPrice: GetSubtotalPrice = ({
  price, quantity,
}) => parseFloat((price * quantity).toFixed(2))

type CustomItemgetterInput = {
  lineItems: Array<{
    imageUrl: string,
    sku,
    isFurniture?: boolean
    isReturnable?: boolean
    arrivalWindow: string
  }>,
  customItems: readonly {
    sku: string,
    listPrice: number
    quantity: number
  }[]
}
export const getCustomItems = ({ lineItems, customItems }: CustomItemgetterInput) => (
  customItems.map((item) => {
    let imageUrl = ''
    let isFurniture = false
    let arrivalWindow = ''
    let isReturnable = false
    let isDigital = false
    let isBackOrder = false
    if (checkIsExtendItem(item)) {
      const warrantyProductId = item?.sku?.split(EXTEND_SKU)?.[1]
      const warrantyProduct = lineItems.find((lineItem) => lineItem.sku === warrantyProductId)
      isFurniture = !!warrantyProduct?.isFurniture
      imageUrl = EXTEND_LOGO
      arrivalWindow = warrantyProduct?.arrivalWindow || arrivalWindow
      isReturnable = !!warrantyProduct?.isReturnable
      isDigital = false
      isBackOrder = false
    }
    const years = parseInt(String(item?.sku?.split(EXTEND_SKU)?.[0].split('-').pop()))
    return {
      ...item,
      imageUrl,
      arrivalWindow,
      isFurniture,
      originalPrice: item.listPrice,
      salePrice: item.listPrice,
      extendedSalePrice: item.listPrice,
      isReturnable,
      isDigital,
      isBackOrder,
      name: `${years} Year Extend Protection Plan`,
      subtotalPrice: getSubtotalPrice({ price: item.listPrice, quantity: item.quantity }),
    }
  })
)
export const isOrderConfirmationPage = () => !!`${window?.location?.href}`.match(/checkout\/order-confirmation\/([a-z0-9]*)$/gi)
